import { Checkbox, Input, OptionLabel } from "./styles";
import { useLayout } from "../../../../../../../../provider/LayoutProvider";
import { useEffect, useState } from "react";

interface ComponentProps {
  label: string;
  value: string;
  name: string;
  cleared: boolean;
  onClick?: () => void;
}

const Filter = ({ label, value, name, cleared, ...rest }: ComponentProps) => {
  const { applyedFilters, setFilters } = useLayout();
  const isChecked = !!applyedFilters[name]?.includes(value);
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    if (cleared) {
      setChecked(false);
    }
  }, [cleared]);

  return (
    <Checkbox>
      <Input
        type="checkbox"
        id={name + "-" + value}
        name={name}
        value={value}
        checked={checked}
        onChange={(event) => {
          setChecked(!checked);
          if (checked) {
            setFilters(name, value, "REMOVE");
          } else {
            setFilters(name, value, "ADD");
          }
        }}
        {...rest}
      />
      <OptionLabel htmlFor={name + "-" + value}>{label}</OptionLabel>
    </Checkbox>
  );
};

export default Filter;
